import { MglValidationService } from '../../../../../shared/services/MglValidationService';
import { AppFormModel } from '../models/AppFormModel';
import { AppApiService } from './AppApiService';
import { AppModelAdapter } from '../helper/AppModelAdapter';
import { AppRateService } from './AppRateService';
import { BasicValidationService } from '../../../../../shared/services/BasicValidationService';
import { MitgliedschaftGutscheinApi } from '../../../../../shared/models/generated/MitgliedschaftMitgliedschaftGutscheinApi';

export class AppValidationService extends MglValidationService<MglModularSystemV2AppDefinition> {
	public static readonly SALESMAM_FIELDS = "#salesmanNo, #salesmanControlDigit";
	public static readonly OfficeaAvertisingKey = '#officeadvertisingkey';
	private readonly appApiService: AppApiService;
	private readonly appRateService: AppRateService;

	constructor(app: { options: MglModularSystemV2AppOptions }, forms: JQuery, cb = (): void => { /* don't care */ }) {
		super(app, forms, cb);
		this.appApiService = new AppApiService(this.options);
		this.appRateService = new AppRateService(this.options);
	}

	public validateSalesmenNo(formModel: AppFormModel,
		successCallback: () => void,
		errorCallback: (jqxhr: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string, profiWerbernummer: string) => void,
		showErrors = false,
		field?: HTMLInputElement): void {
		let reqStarted = false;
		const validation = this.getValidationApi();
		const successFunc = (): void => {
			successCallback();
			if (field) {
				$(AppValidationService.SALESMAM_FIELDS).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, null);
				if (reqStarted) {
					validation.stopRequest(field, true);
					validation.element($(AppValidationService.SALESMAM_FIELDS));
					this.decorateElement(AppValidationService.SALESMAM_FIELDS);
				}
			}
		};
		if (!formModel.Profiwerbernummer) {
			successFunc();
			return;
		}
		if (field) {
			reqStarted = true;
			validation.startRequest(field);
		}
		this.appApiService.checkSalesmanNumbers(AppModelAdapter.getProfiwerberApi(formModel, this.options.app.advertisingkey),
			successFunc,
			(jqxhr, textStatus, errorThrown) => {
				errorCallback(jqxhr, textStatus, errorThrown, formModel.Profiwerbernummer);
				let id = "182000";
				if (showErrors && jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
					let msg = "", src = field.name;
					for (const errMsg of jqxhr.responseJSON.Messages) {
						if (errMsg.Id) {
							id = errMsg.Id;
							msg = errMsg.Message;
							if (errMsg.Source) {
								src = errMsg.Source;
								break;
							}
						}
					}
					const opts: Record<string, any> = {};
					if (field) {
						if (reqStarted) {
							validation.stopRequest(field, false);
						}
					} else {
						opts[this.lookupServerFieldnames[src] || "Profiwerbernummer"] = this.options.app.validationmessages.backend[`code_${id}`] || msg;
						this.showErrors(opts);
					}
				}
				if (field) {
					$(AppValidationService.SALESMAM_FIELDS).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, id);
					if (showErrors) {
						validation.element($(AppValidationService.SALESMAM_FIELDS));
						this.decorateElement(AppValidationService.SALESMAM_FIELDS);
					}
				}
			});
	}

	public validateBonuscode(bonuscode: string,
		successCallback: () => void,
		errorCallback: () => void,
		field?: HTMLInputElement): void {
		let reqStatred = false;
		const validation = this.getValidationApi();
		const successFunc = (): void => {
			successCallback();
			if (field) {
				$(field).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, null);
				if (reqStatred) {
					validation.stopRequest(field, true);
					validation.element($(field));
					this.decorateElement(field);
				}
			}
		};
		if (!bonuscode && field) {
			bonuscode = field.value;
		}
		if (!bonuscode) {
			errorCallback();
			return;
		}
		if (field) {
			reqStatred = true;
			validation.startRequest(field);
		}
		this.appApiService.checkBonuscode(new MitgliedschaftGutscheinApi({ GutscheinCode: bonuscode }),
			successFunc,
			(jqxhr: JQueryXHR) => {
				if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
					const messages = (jqxhr.responseJSON as ApiResponse<any>).Messages;
					for (const message of messages) {
						if (message.Id) {
							const id = message.Id.toString();
							this.setServerValidationBackendFlag(false, "Bonuscode", id);
							if (reqStatred) {
								validation.stopRequest(field, true);
							}
						}
					}
				}
				errorCallback();
			});
	}

	public validateOfficeAdvertisingKey(officeAKey: string,
		successCallback: (isValid: boolean) => void,
		errorCallback: () => void,
		field?: HTMLInputElement): void {
		let startRequest = false;
		const validation = this.getValidationApi();
		const successFunc = (): void => {
			successCallback(true);
			if (field) {
				$(AppValidationService.OfficeaAvertisingKey).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, null);
				if (startRequest) {
					validation.stopRequest(field, true);
					validation.element($(AppValidationService.OfficeaAvertisingKey));
					this.decorateElement(AppValidationService.OfficeaAvertisingKey);
				}
			}
		};
		if (!officeAKey && field) {
			officeAKey = field.value;
		}
		if (!officeAKey) {
			errorCallback();
			return;
		}
		if (field) {
			startRequest = true;
			validation.startRequest(field);
		}
		this.appApiService.checkMglWbs(officeAKey,
			successFunc,
			(jqxhr: JQueryXHR) => {
				if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
					this.setServerValidationBackendFlag(false, "GeschaeftsstellenWBS", '300000');
					if (startRequest) {
						validation.stopRequest(field, true);
					}
				}
				errorCallback();
			});
	}

	private getValidationApi(): {
		element: (element: JQuery) => void,
		startRequest: (element: HTMLInputElement) => void,
		stopRequest: (element: HTMLInputElement, showErrors: boolean) => void
	} {
		return $(this.forms)[0].validation;
	}

	public addCustomMethods(): void {
		super.addCustomMethods();

		let mglratecheckMsg = "";
		$.validator.addMethod('mglratecheck', (value, element: HTMLInputElement) => {
			let isValid = false;
			this.appRateService.rateUpdateForValidation(() => {
				isValid = true;
			}, (data) => {
				[isValid, mglratecheckMsg] = this.evaluateMglRateCheckResponse(element, data);
			});

			return isValid;
		},
			() => mglratecheckMsg
		);

		$.validator.addMethod('startofmembershipcheck', this.validatorStartOfMembershipCheck.bind(this));
		$.validator.addMethod('startofmembership', this.validatorStartOfMembership.bind(this));
		$.validator.addMethod('startofmembershippredate2m', this.validatorMembershipPredate.bind(this));
		$.validator.addMethod('startofmembershippredate6m', this.validatorMembershipPredate.bind(this));
	}

	private validatorMembershipPredate(value: any, element: HTMLElement): boolean {
		const currentStartDate = AppModelAdapter.getStartOfMembershipDate(value);
		const preDateSlection: Record<string, any> = {
			'Vordatierung 2 Monate': 2,
			'Vordatierung 6 Monate': 6
		};
		let isPredateAvailable = true;
		if (preDateSlection[$(element).attr('data-predate')]) {
			isPredateAvailable = moment(moment(currentStartDate)).diff(moment(), 'months', true) <= preDateSlection[$(element).attr('data-predate')];
		}
		return isPredateAvailable;
	}
	private validatorStartOfMembership(value: any): boolean {
		let isValid = true;
		if (value.length !== 0 && value !== "__.____") {
			// Validate input format dd.yyyy
			isValid = (/(0[1-9]|1[012]).[0-9]{4}/.test(value));
			if (isValid) {
				const currentStartDate = AppModelAdapter.getStartOfMembershipDate(value);
				// Entered start date should not being older than current.
				if (moment().format("MM.YYYY") !== value && moment(currentStartDate).utc().isBefore(moment(new Date()).subtract(1, "day"))) {
					isValid = false;
				}
			}
		}
		return isValid;
	}

	private validatorStartOfMembershipCheck(value: any): boolean {
		const currentStartDate = AppModelAdapter.getStartOfMembershipDate(value);
		let isValid = false;
		const successFunc = (): void => {
			isValid = true;
		};
		const errorFunc = (): void => {
			isValid = false;
		};
		this.appApiService.makeStartOfMembershipRequest(currentStartDate, successFunc, () => {
			errorFunc();
		});
		return isValid;
	}
}
